import { Storage } from '@ionic/storage-angular';
import { CommonProvider } from './../commonServices/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Apiurl } from '../commonServices/route';
import { Location } from '@angular/common';
import { FAQItem, GroupItem } from '../notifications/notifications.page';
import { DeviceInfo } from 'src/data/device-info';
import { AppInfo } from 'src/data/mygolf.data';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { ModalController, NavController, Platform } from '@ionic/angular';
import { DeviceService } from 'src/providers/device-service/device-service';
import * as moment from 'moment';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';
import * as globals from 'globals';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.page.html',
  styleUrls: ['./faq.page.scss'],
})
export class FaqPage implements OnInit {
  // groupItems: any;
  // searchingMode: boolean = false;
  headers: any;
  deviceInfo: DeviceInfo = {
    deviceId: 'unknown',
    virtual: true,
  };
  appInfo: AppInfo = {};

  faqItems: Array<FAQItem> = new Array<FAQItem>();
  groupItems: Array<GroupItem> = new Array<GroupItem>();
  searchQuery: string;
  originalGroups: Array<any>;
  searchingMode = false;

  currentYear: string;
  constructor(
    private location: Location,
    private router: Router,
    private commonProvider: CommonProvider,
    private storage: Storage,
    private navCtrl: NavController,
    private deviceService: DeviceService,
    private platform: Platform,
    private modalCtrl: ModalController,
    private flightService: ClubFlightService,
    private mg2uUtil: mygolfUtils
  ) {
    this.platform = platform;
    this.currentYear = moment().format('YYYY');
    // this.modalCtrl.dismiss();
  }

  ngOnInit() {
    this.deviceService.getDeviceInfo().then((deviceInfo: DeviceInfo) => {
      this.deviceInfo = deviceInfo;
    });
    this.deviceService.getAppInfo().then((appInfo: AppInfo) => {
      this.appInfo = appInfo;
    });
    this.onRefresh();
  }

  gotopage() {
    this.location.back();
  }

  // async onRefresh() {
  //   await this.storage.get('authToken').then((result: any) => {

  //     this.headers = result;
  //   })
  //   this.commonProvider.GetMethod(Apiurl.RoutePath + Apiurl.faqdetails, null, this.headers).
  //   then((res: any) => {

  //     this.groupItems = res;

  //   })
  // }
  onRefresh(clear: boolean = false) {
    const _faqAttr = this.mg2uUtil.getSettingsAttribute();
    const _isClubSpecific = this.mg2uUtil.getClubSpecific();
    let _faqJson = null;
    console.debug('settings page : ', _faqAttr, _isClubSpecific, globals.clubId);
    if (_isClubSpecific && globals.appType && globals.clubId) {
      const hasClubSpec = _faqAttr.clubSpecific.filter(c => c.clubId === globals.clubId);
      console.debug('settings page : ', hasClubSpec, globals.clubId);
      if (hasClubSpec?.length) {
        hasClubSpec.map(c => {
          _faqJson = c.faqPage;
        });
      } else {
        _faqJson = _faqAttr.main.faqPage;
      }
    } else {
      _faqJson = _faqAttr.main.faqPage;
    }
    this.searchingMode = false;
    if (clear) {
      this.searchQuery = '';
    }

    this.flightService.getFAQ(_faqJson).subscribe((groupItems: Array<GroupItem>) => {
      if (groupItems && groupItems.length > 0) {
        this.groupItems = groupItems;
        this.originalGroups = this.groupItems;
        // this.originalGroups.push(this.groupItems)
      }
    });
  }

  toggleBookingClick(type: number) {}

  expandPanel(item) {
    const _item = item;
    this.groupItems.forEach(element => {
      element.groupContent.forEach(item => {
        if (item !== _item) {
          item.expand = false;
        } else {
          item.expand = !item.expand;
        }
      });
    });
    // _item.expand = true;
    //   this.faqItems.forEach((item: FAQItem)=>{
    //       item.expand = false;
    //   })
    //   item.expand = true;
  }
  onSearchInput(ev) {
    // this.filteredBooking = [];
    if (this.searchQuery.length === 0) {
      this.searchingMode = false;
      this.onRefresh();
      return false;
    }
    this.searchingMode = true;
    let _filteredFaq: Array<FAQItem> = [];
    // let _filteredGroup = this.originalGroups.forEach((tGroup: GroupItem)=>{
    //     _filteredFaq = tGroup.groupContent.filter((tFAQ: FAQItem)=>{
    //         if(tFAQ.title.toLowerCase().includes(this.searchQuery.toLowerCase()))
    //             return 1
    //         else if(tFAQ.content.toLowerCase().includes(this.searchQuery.toLowerCase()))
    //             return 1
    //         else 0
    //     })
    // })

    const _filteredGroup = this.originalGroups.forEach((tGroup: GroupItem) => {
      tGroup.groupContent.forEach((faq: FAQItem) => {
        _filteredFaq.push(faq);
      });
    });
    _filteredFaq = _filteredFaq.filter((tFAQ: FAQItem) => {
      if (tFAQ.title.toLowerCase().includes(this.searchQuery.toLowerCase())) {
        return 1;
      } else if (tFAQ.content.toLowerCase().includes(this.searchQuery.toLowerCase())) {
        return 1;
      } else {
        0;
      }
    });
    // if(_filteredGroup && _filteredGroup.length > 0)
    //     this.groupItems = _filteredGroup:null;

    this.faqItems = _filteredFaq;
    if (this.faqItems && this.faqItems.length > 0) {
      this.faqItems[0].expand = true;
    }
    // let _filteredBooking = this.bookingList.filter((tBooking: TeeTimeBooking) => {
    //     if (this.selectedSearchOpt.type === 'bookingRef') return tBooking.bookingReference.trim().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
    //     else if (this.selectedSearchOpt.type === 'mg2uId') {
    //         let _player;
    //         _player = tBooking.bookingPlayers.forEach((player: TeeTimeBookingPlayer) => {
    //             return (String(player.player.id) === this.searchQuery.trim())
    //         })
    //         if (!_player || _player.length === 0) {
    //             return String(tBooking.bookedByPlayer.id) === this.searchQuery.trim()
    //         }
    //     }

    //     // return tBooking.booking.trim().toLowerCase().includes(this.searchQuery.trim().toLowerCase())
    // }).sort((a, b) => {
    //     if (a.slotAssigned.startCourse.displayOrder < b.slotAssigned.startCourse.displayOrder)
    //         return -1;
    //     else if (a.slotAssigned.startCourse.displayOrder > b.slotAssigned.startCourse.displayOrder)
    //         return 1;
    //     else 0;
    // }).sort((a, b) => {
    //     if (a.slotAssigned.teeOffTime < b.slotAssigned.teeOffTime)
    //         return -1;
    //     else if (a.slotAssigned.teeOffTime > b.slotAssigned.teeOffTime)
    //         return 1;
    //     else 0;
    // });

    // if (_filteredBooking.length > 0 && _filteredBooking.length === 1) {
    //     this.navCtrl.push(BookingDetailsPage, {
    //         fromClub: true,
    //         teeSlotNew: false,
    //         bookingSlot: _filteredBooking[0]
    //     })
    // } else if (_filteredBooking.length > 1) {
    //     this.filteredBooking = _filteredBooking;
    // }
    // this._clearAndRefresh(null, null);
  }
  onSearchCancel(ev) {
    // this._clearAndRefresh(null, null);

    this.searchingMode = false;
    this.onRefresh();
  }

  versionCode() {
    // return this.platform.platforms.  .versions()
  }

  isCordova() {
    return this.platform.is('capacitor');
  }

  toDisplay(item: any) {
    // console.debug("to display", item?.whichPlatform, item?.whichPlatform?.toLowerCase(),
    // this.platform.is(item?.whichPlatform?.toLowerCase()),
    // this.platform.platforms())
    if (item?.whichPlatform === undefined) {
      return true;
    } else if (this.platform.is(item?.whichPlatform?.toLowerCase())) {
      return true;
    } else if (!this.platform.is('ios') && !this.platform.is('android')) {
      return true;
    } else {
      return false;
    }
  }
}
